import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModelOnboardingHomeComponent } from '@angular-workspace/feature';
import { ProviderSidebarComponent } from '../../sidebar/provider-sidebar.component';
import { PageHeaderComponent } from '../../../shared/components/page-header/page-header.component';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { ToasterService } from '../../../services/toaster.service';

@Component({
  selector: 'app-provider-add-model',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ProviderSidebarComponent,
    PageHeaderComponent,
    ModelOnboardingHomeComponent,
  ],
  templateUrl: './add-model.component.html',
  styleUrl: './add-model.component.scss',
})
export class ProviderAddModelComponent {
  private readonly toasterService = inject(ToasterService);

  onSubmitError(message: string): void {
    this.toasterService.error(message);
  }

  onSubmitSuccess(message: string): void {
    this.toasterService.success(message);
  }
}
